import { PolicyHome } from '@models/policy-home';
import { PolicyOther } from '@models/policy-other';

export interface MultiMapState {
  policy?: PolicyHome | PolicyOther;
  pageCanReturn: boolean;
  accessPoint: MultiMapAccessPoint;
}

export enum MultiMapAccessPoint {
  CAROUSEL = 'Netflix',
  ALERT = 'Alerta',
  MENU = 'Menú',
  PRODUCT = 'Producto',
  PUSH_NOTIFICATION = 'Notificación push',
  DEEPLINK = 'Web Multimaps',
  NEXA_SERVICES = 'Bloque Servicios Nexa'
}

export interface MultiMapLoginTokenResponse {
  documentNumber: string;
  policies: {
    policy_number: string;
    is_selectable: boolean;
    address: {
      MA_province: string;
      MA_city: string;
      MA_postal_code: string;
      MA_road_type: string;
      MA_street: string;
      MA_gate: string;
      MA_block: string;
      MA_floor: string;
      MA_road_number: string;
      MA_stairs: string;
      MA_address_additional: string;
    }
  }[];
  validationToken: string;
}

export interface MultiMapRegisterTokenResponse {
  document: string;
  first_name: string;
  last_name: string;
  second_last_name: string;
  birthdate: string;
  email: string;
  phone_prefix: string;
  phone: string;
  road_type: string;
  street: string;
  road_number: number;
  stairs: string;
  block: string;
  floor: string;
  gate: string;
  address_additional: string;
  postal_code: string;
  city: string;
  province: string;
  policies: {
    policy_number: string;
    is_selectable: boolean;
    address: {
      MA_province: string;
      MA_city: string;
      MA_postal_code: string;
      MA_road_type: string;
      MA_street: string;
      MA_gate: string;
      MA_block: string;
      MA_floor: string;
      MA_road_number: string;
      MA_stairs: string;
      MA_address_additional: string;
    }
  }[];
  validationToken: string;
}

export interface MultiMapLoginResponse {
  token: string;
  mapfre_id: string;
}

export interface MultiMapRegisterResponse extends MultiMapLoginResponse {
  email: string;
  first_name: string;
  last_name: string;
  second_last_name: string;
  phone_prefix: string;
  phone: string;
  birthdate: string;
  road_type: string;
  street: string;
  road_number: number;
  city: string;
  postal_code: string;
  state: string;
  stairs: string;
  gate: string;
  block: string;
  floor: string;
  province: string;
  address_additional: string;
  consent_commercial: boolean;
  consent_contract: boolean;
  consent_club_mapfre: boolean;
  signature: string;
  document: string;
  policies: {
    policy_number: string;
    is_selectable: boolean;
    address: {
      provincia: string;
      localidad: string;
      cod_postal: string;
      tipo_via: string;
      nombre_via: string;
      portal: string;
      letra: string;
      piso: string;
      num_via: string;
      escalera: string;
      complemento_dir: string;
    }
  }[];
}

export enum MultiMapError {
  USER_NOT_FOUND = 'USER_NOT_FOUND'
}

export interface MultiMapEvent {
  namespace: string;
  type: MultiMapEventType;
  data?: any;
}

export type MultiMapEventType = 'closeIframe' | 'trackPage' | 'trackClick' | 'registerOperation' | 'downloadBase64Pdf';

export interface MultiMapNavigationEventData {
  stepName: string;
  stepNumber?: string;
  stepProcess: string;
  stepSection?: string;

  selectedCity?: string;
  selectedSpecialty?: string;
  selectedProduct?: string;

  errorType?: string;
  errorMessage?: any;
}

export interface MultiMapClickEventData extends MultiMapNavigationEventData {
  eventCategory: string;
  eventAction: string;
  eventLabel: string;
}

export interface MultiMapOperationRegisterEventData {
  id: MultiMapOperationRegisterEventId;
  error?: any;
  data?: any;
}

export enum MultiMapOperationRegisterEventId {
  REQUEST_INIT = 'requestInit',
  REQUEST_OK = 'requestOK',
  REQUEST_KO = 'requestKO',
  REQUEST_LIST = 'requestList',
  REQUEST_LIST_KO = 'requestListKO',
  REQUEST_DETAIL_OK = 'requestDetailOK',
  REQUEST_SEND_MESSAGE_OK = 'requestSendMessageOK',
  REQUEST_SEND_MESSAGE_KO = 'requestSendMessageKO'
}

export const MULTIMAP_EVENTS_NAMESPACE = 'multimap:mets';

export const MULTIMAP_PARAM_TOKEN = 'token';
export const MULTIMAP_PARAM_ORIGIN = 'origin';

export const MULTIMAP_ORIGIN_METS = 'mets';
export const MULTIMAP_ORIGIN_METS_WEB = 'mets_web';
